import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Antd from 'ant-design-vue';
import '@babel/polyfill';
import 'ant-design-vue/dist/antd.css';
import '@/https/axios.js'
import '@/https/way.js'
import '@/utils/preventReClick' //防多次点击，重复提交
import moment from 'moment'; //导入模块
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/common.css' 
import './assets/css/common2.scss' 
import lodash from 'lodash'
import './assets/css/commonTan.scss' 

//require('es6-promise').polyfill();
//require('es6-promise/auto');
// import './utils/rem'
import vcolorpicker from 'vcolorpicker'
import Print from 'vue-print-nb'
import JsonExcel from 'vue-json-excel'
import ExportPdf from "./utils/ExportPdf";
import { globalStompService, createGlobalStompScope } from './utils/stomp';

Vue.use(Print)
Vue.use(vcolorpicker)
Vue.prototype.$moment = moment;

Vue.prototype.$lodash = lodash
Vue.use(ElementUI);
//由于4.9.0版本echarts不支持最新版本的仪表盘画法，所以引入5.0.2版本的echarts导致引用方式改变
var echarts = require('echarts'); 
// 图表 心跳
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)
Vue.component('downloadExcel', JsonExcel)


// 下拉刷新
import VueScroller from 'vue-scroller'
Vue.use(VueScroller)

Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts;
Vue.prototype.$stompService = globalStompService;
Vue.prototype.$createStompScope = createGlobalStompScope;

Vue.use(Antd)

Vue.use(ExportPdf);

// 路由首位
router.beforeEach((to, from, next) => {
  console.log(from);
  if (to.path == '/aiShare') {
	next()
	return
  }
  if (to.path == '/thirdLogin') {
	next()
	return
  }
  let hasLogin = document.cookie.indexOf("userInfo");
  console.log(hasLogin);
  var val = 1;
  if (hasLogin != -1) {
    next()
  } else {
    if (to.path == '/login') {
      next()
    } else {
      next({
        replace: true,
        name: 'Login',
      })
    }
  }
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
